import { quoteLineType } from '../../types'
import { IngramMicroSftpItem } from './ingramMicroTypes'

export function ingramMicroItemToLineItem(
  lineNumber: number,
  _mfgPN: string,
  item: IngramMicroSftpItem,
): Partial<quoteLineType> {
  return {
    LineItemId: crypto.randomUUID(),
    LineNumber: lineNumber,
    Bundle: null,
    Provider: 'Ingram Micro',
    Manufacturer: item.manufacturerName,
    MfrPartNumber: item.mfgPN,
    VendorPartNumber: item.ingramSKU,
    Description: [item.description1, item.description2].filter(Boolean).join(' '),
    Qty: 1,
    UnitCost: item.cost,
    MSRP: item.listPrice,
    UPC: item.upcCode,
  }
}
